import React from 'react';

export const RedCircleCross = () => (
  <svg
    width="26"
    height="24"
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 2.25C9.48438 2.25 6.29688 4.125 4.51562 7.125C2.78125 10.1719 2.78125 13.875 4.51562 16.875C6.29688 19.9219 9.48438 21.75 13 21.75C16.4688 21.75 19.6562 19.9219 21.4375 16.875C23.1719 13.875 23.1719 10.1719 21.4375 7.125C19.6562 4.125 16.4688 2.25 13 2.25ZM13 24C8.6875 24 4.75 21.75 2.59375 18C0.4375 14.2969 0.4375 9.75 2.59375 6C4.75 2.29688 8.6875 0 13 0C17.2656 0 21.2031 2.29688 23.3594 6C25.5156 9.75 25.5156 14.2969 23.3594 18C21.2031 21.75 17.2656 24 13 24ZM9.20312 8.20312C9.625 7.78125 10.3281 7.78125 10.75 8.20312L12.9531 10.4062L15.1562 8.20312C15.625 7.78125 16.3281 7.78125 16.75 8.20312C17.2188 8.67188 17.2188 9.375 16.75 9.79688L14.5469 12L16.75 14.2031C17.2188 14.6719 17.2188 15.375 16.75 15.7969C16.3281 16.2656 15.625 16.2656 15.1562 15.7969L12.9531 13.5938L10.75 15.7969C10.3281 16.2656 9.625 16.2656 9.20312 15.7969C8.73438 15.375 8.73438 14.6719 9.20312 14.2031L11.4062 12L9.20312 9.79688C8.73438 9.375 8.73438 8.67188 9.20312 8.20312Z"
      fill="#DB3737"
    />
  </svg>
);
